import { Radio } from '@shipengine/giger';
import { getPaymentOptionStyles, getPaymentOptionTextStyles, getPaymentOptionLabelStyles, getPaymentOptionImageStyles, getPaymentOptionContentStyles } from './PaymentOptionStyles.js';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import { OptionImgSize } from '../../../types/types.js';

const PaymentOption = _ref => {
  let {
    value,
    selectedValue,
    label,
    children,
    image,
    size = OptionImgSize.REGULAR,
    onChange
  } = _ref;
  const isChecked = selectedValue === value;
  return jsxs("div", {
    css: getPaymentOptionStyles,
    children: [jsx(Radio, {
      name: label,
      value: value,
      checked: isChecked,
      onChange: onChange,
      children: jsxs("div", {
        css: getPaymentOptionTextStyles,
        children: [jsx("span", {
          css: getPaymentOptionLabelStyles,
          children: label
        }), image && jsx("img", {
          css: getPaymentOptionImageStyles(size),
          src: image,
          alt: label
        })]
      })
    }), jsx("div", {
      css: getPaymentOptionContentStyles(isChecked),
      "aria-hidden": !isChecked,
      children: children
    })]
  });
};
PaymentOption.displayName = 'PaymentOption';

export { PaymentOption, PaymentOption as default };
//# sourceMappingURL=PaymentOption.js.map
